import { render, staticRenderFns } from "./TreeDialog.vue?vue&type=template&id=cb235904&scoped=true"
import script from "./TreeDialog.vue?vue&type=script&lang=js"
export * from "./TreeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb235904",
  null
  
)

export default component.exports